// src/utils/dateUtils.js

// Parse "YYYY-MM-DD" als lokales Datum (nicht UTC)
// Wichtig: new Date("2026-02-03") wird als UTC interpretiert, was in CET zu 2026-02-02 23:00 führt
export const parseDateAsLocal = (dateString) => {
  if (!dateString) return null;
  const parts = dateString.split('-');
  if (parts.length !== 3) return new Date(dateString);
  return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
};

export const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error('Ungültiges Datum:', dateString);
      return '';
    }
    return date.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (e) {
    console.error('Fehler beim Formatieren des Datums:', e);
    return '';
  }
};

export const formatDateDE = (date) => {
  if (!(date instanceof Date) || isNaN(date)) {
    return '';
  }
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatDateForAPI = (date) => {
  try {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      console.error('Ungültiges Datum für API:', date);
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    console.log('Formatiertes Datum für API:', `${year}-${month}-${day}`);
    return `${year}-${month}-${day}`;
  } catch (e) {
    console.error('Fehler beim Formatieren des Datums für API:', e);
    return '';
  }
};

export const getWeekDates = (date) => {
  try {
    // Verwende das aktuelle Datum, wenn keines übergeben wurde
    const currentDate = date ? new Date(date) : new Date();
    
    if (isNaN(currentDate.getTime())) {
      console.error('Ungültiges Datum für Wochenberechnung:', date);
      return { startDate: new Date(), endDate: new Date() };
    }
    
    // Setze auf Montag (1) der aktuellen Woche
    const day = currentDate.getDay() || 7; // Sonntag ist 0, wir wollen 7
    const diff = currentDate.getDate() - day + 1;
    
    const startDate = new Date(currentDate);
    startDate.setDate(diff);
    startDate.setHours(0, 0, 0, 0);
    
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    endDate.setHours(23, 59, 59, 999);
    
    console.log('Berechnete Wochendaten:', {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    });
    
    return { startDate, endDate };
  } catch (e) {
    console.error('Fehler bei der Wochenberechnung:', e);
    return { startDate: new Date(), endDate: new Date() };
  }
};

export const getWeekNumber = (date) => {
  try {
    const currentDate = new Date(date);
    if (isNaN(currentDate.getTime())) {
      console.error('Ungültiges Datum für Kalenderwoche:', date);
      return '';
    }
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(currentDate.getDate() + 3 - (currentDate.getDay() + 6) % 7);
    const week1 = new Date(currentDate.getFullYear(), 0, 4);
    return 1 + Math.round(((currentDate.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  } catch (e) {
    console.error('Fehler bei der Berechnung der Kalenderwoche:', e);
    return '';
  }
};